import PagesGenerator from './pages-generator';

const toggleSVGLoadingIndicator = (bool) => {
  const { editor } = INKIVE.Tool.getInstance();
  editor.loadingElement(bool);
};

const toggleUI = (enable = true) => {
  const { editor } = INKIVE.Tool.getInstance();
  const selectionDisableClass = 'screenshot-temp-canvas';
  const popupMenu = document.querySelector('#element-popupmenu > .root-popupmenu');
  const svgroot = document.getElementById('svgroot');

  if (enable) {
    INKIVE.Tool.enableUI();
    popupMenu?.classList?.remove('disabled');
    svgroot.classList.remove(selectionDisableClass);
    svgroot.style.cursor = '';
    editor.canvas.call('advice.show', 'table-of-contents-ready');
  } else {
    INKIVE.Tool.disableUI();
    document.getElementById('pages-panel').classList.remove('disabled');
    popupMenu?.classList?.add('disabled');
    svgroot.classList.add(selectionDisableClass);
    svgroot.style.cursor = 'not-allowed';
    editor.canvas.call('advice.show', 'generating-table-of-contents');
  }
};

export const saveTableOfContentsPages = async (pages) => {
  if (!pages.length) return INKIVE.Modal.togglePageLoader(false);

  toggleSVGLoadingIndicator(true);
  toggleUI(false);

  const pagesGenerator = new PagesGenerator(pages).initialize();
  await pagesGenerator.generatePages();

  INKIVE.Modal.togglePageLoader(false);
  toggleSVGLoadingIndicator(false);
  toggleUI(true);

  INKIVE.EditorFacade.trigger('history.change');
};
